import { Component, OnDestroy, Renderer2, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';

import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { UsuarioService } from '../../../providers/usuario-service';
import { ModalJustificativaContratoPage } from '../../modais/modal-justificativa-contrato/modal-justificativa-contrato';
import { ModalProdutoContratoPage } from '../../modais/modal-produto-contrato/modal-produto-contrato';
import { AlertService } from '../../../providers/alert-service';
import { FileService } from '../../../providers/file-service';
import { ContratoService } from '../../../providers/contrato-service';
import { MenuService } from '../../../providers/menu-service';

import { ModulosController } from '../modulos-controller';

import { ModalPreVisualizarContratosPage } from '../../modais/modal-pre-visualizacao/contratos/modal-pv-contratos';
import { ModalArquivosPage } from '../../modais/modal-arquivos/modal-arquivos';
import { ModalNaoSeAplicaPage } from "../../modais/nao-se-aplica/modal-nao-se-aplica";
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AssinaturaService } from '../../../assinatura/assinatura-service';

declare var jsPDF: any;

@Component({
  selector: 'page-contratos',
  templateUrl: 'contratos.html'
})
export class ContratosPage extends ModulosController implements OnInit, OnDestroy {

  global: any = [];

  listaDados: any = [];
  codigoModulo: any = null;
  listaDadosAcrescimo: any = [];
  listaAnalises: any = [];
  PCAATiva: any = null;
  usuario: any;
  loading: boolean = true;
  loadingPagContrato: boolean = true;
  loadingListaContratos: boolean = false;
  loadingAcrescimosOuSupressoes: boolean = false;
  loadingGerarResumoContrato = false;
  isPoderExecutivo: boolean = false;
  tiposArquivosAceitos: string = "application/xls";
  incluindoNoCertificado: boolean = false;
  shownGroup: any = [];
  pageListaContratos: number = 1;
  pageAcresDec: number = 1;
  statusAnalise1: any = {
    id: "2",
    dsStatus: "Em Andamento"
  };
  statusAnalise2: any = {
    id: "1",
    dsStatus: "Não iniciado"
  };
  statusAnalise3: any = {
    id: "3",
    dsStatus: "Finalizado"
  };
  pendencias: any = [];
  pendencias1: any = [];
  pendencias2: any = [];
  pendencias3: any = [];
  pendencias4: any = [];
  listaErros: any;
  page1: number = 1;

  pagination = {
    TotalItems: 100,
    CurrentPage: 1,
    PageSize: 10,
    TotalPageLinkButtons: 5,
    RowsPerPageOptions: [10]
  };

  order: string = 'nmAditivo';
  reverse: boolean = false;
  static isAlertaAberto: boolean = false;

  filter: any = { nmContrato: '' };

  analise: any = null;

  habilitaBotaoImportaContrato: boolean = true;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  resumoContratoArquivo: any;
  disbaleBotaoGerarResumoContrato = false;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    private fileService: FileService,
    public contratoService: ContratoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService,
    private renderer: Renderer2,
    private assinaturaService: AssinaturaService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.PCAATiva = this.gestaoPcaService.getPCA();
    this.usuario = usuarioService.obtemUsuario();

    this.analise = this.navParams.get('analise');

    if (this.isJurisdicionado) {
      this.codigoModulo = this.navParams.get('analise').idModuloPca;
    }

    this.carregarDados();

    this.setModuloId(5);

    this.contratoService.getArquivoResumoContrato(this.PCAATiva.id).subscribe(result => {
      this.resumoContratoArquivo = result;
    }, error => console.log(error));
  }

  carregarDados() {
    if (this.isJurisdicionado) {

      this.loadingListaContratos = this.loadingPagContrato = this.loadingAcrescimosOuSupressoes = true;

      this.contratoService.listarPorPCAPag(this.pagination.CurrentPage, '').subscribe(data => {
        this.listaDados = data.contratosModel;
        this.loadingListaContratos = this.loadingPagContrato = this.loading = false;
        this.pagination.TotalItems = data.qtdPags;
      }, error => {
        console.log("erro: " + error);
        this.loadingListaContratos = this.loadingPagContrato = this.loading = false;
      });

      this.contratoService.listarForaDoLimitePorPCA().subscribe(data => {
        this.listaDadosAcrescimo = data;
        this.loadingAcrescimosOuSupressoes = this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loadingAcrescimosOuSupressoes = this.loading = false;
      });
    }
    else {
      this.contratoService.listarAnalisesContrato().subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.setIdModuloPca(this.listaAnalises[0].idModuloPca);

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }
  }

  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };

  cargaEmMassaProdutos(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?",
      callback => {
        if (callback) {
          this.fileService.cargaProdutos(event).subscribe(
            () => {
              this.inputFileCMVar.nativeElement.value = "";
              this.alertService.mostraAlerta("", "Detalhamento dos Aditivos importado com sucesso.");
              this.carregarDados();
            }, error => {
              this.inputFileCMVar.nativeElement.value = "";
              this.alertService.mostraAlerta("Falha ao carregar o arquivo.", error.mensagem);
            });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
        }
      }
    );
  }

  downloadDoModelo() {
    this.fileService.downloadModeloCargaProduto();
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  formatarPorcentagem(valor) {
    let valorString = valor.toString();

    if (valorString.indexOf('.') != -1) {
      let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
      let numeroDeCasasDecimais = 2;
      valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
    }

    return valorString.replace('.', ',') + "%";
  }

  adicionarProdutos(aditivo, contrato) {
    let titulo = "Produtos do Aditivo " + aditivo.nmAditivo;

    let modal = this.modalCtrl.create(ModalProdutoContratoPage,
      {
        param1: titulo,
        idModuloPca: contrato.idModuloPca,
        aditivo: aditivo,
        IdProcesso: contrato.nmContrato,
        tipoAnalise: '49',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.carregarDados();
      }
    });

    modal.present();
  }

  adicionarJustificativa(analise) {
    let titulo = analise.contrato.nmContrato;

    let modal = this.modalCtrl.create(ModalJustificativaContratoPage,
      {
        param1: titulo,
        analise: analise,
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.alertService.mostraAlerta("", "Justificativa salva com sucesso!");
      }
    });

    modal.present();
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.contratoService.obterIdPaginaContrato();
    this.menuService.redirecionarSubPagina(this.contratoService.obterIdPaginaContrato(), analise);
  }

  // mudar aqui
  abrirTermoReferencia(item) {
    let titulo = "Documentos";
    // console.log(JSON.stringify(item));

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.nmContrato,
        idModuloPCA: this.codigoModulo,
        tipoAnalise: '49',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemArquivo: "Contrato: " + item.nmContrato,
        origemFilter: 'CONTRATO',
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }

  somarValorDosAcrescimos(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      total += aditivo.totalAcrescimo
    });

    return this.formatarValorNumerico(total);
  }

  somarValorDasSupressoes(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      total += Math.abs(aditivo.totalSupressao)
    });

    return this.formatarValorNumerico(total);
  }

  calcularDiferencaAcrescimos(analise) {
    let totalPorcentagem: any = 0;

    analise.contrato.aditivos.forEach(aditivo => {
      aditivo.produtos.forEach(produto => {
        if (produto.tipo == "Acréscimo") {
          totalPorcentagem += this.contratoService.calculaLimiteLegalProduto(produto);
        }
      });
    });

    return this.contratoService.formatarPorcentagem(totalPorcentagem);
  }

  calcularDiferencaSupressoes(analise) {
    let totalPorcentagem: any = 0;

    analise.contrato.aditivos.forEach(aditivo => {
      aditivo.produtos.forEach(produto => {
        if (produto.tipo == "Supressão") {
          totalPorcentagem += this.contratoService.calculaLimiteLegalProduto(produto);
        }
      });
    });

    return this.contratoService.formatarPorcentagem(totalPorcentagem);
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 20;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 20;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  previsualizarCertificado() {
    this.apresentaModalPreVisualizacao("Pré-visualização do Certificado", ModalPreVisualizarContratosPage);
  }

  apresentaModalPreVisualizacao(titulo: String, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, jurisdicionado: this.isJurisdicionado });
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }

  finalizarModulo() {
    this.alertService.mostraModalConfirmacao("Finalizar Módulo", "Confirma finalização do módulo de contratos?", callback => {
      if (callback) {

        this.loading = true;

        this.contratoService.finalizarModuloContratos().subscribe(data => {
          this.alertService.mostraAlerta("Contratos", "Módulo finalizado com sucesso.");
          // this.carregarDados();
          this.voltarPCA();
        }, error => {

          this.listaErros = "<br />";

          if (error.inconsistencias instanceof Array) {
            error.inconsistencias.forEach(err => {
              if (err.includes("sem o termo de referência inserido")) {
                // this.pendencias = erro.listaErros;
                this.listaErros += "Existem contratos sem o termo de referência inserido. <br />"
              }
              if (err.includes("com o valor total dos produtos igual à zero")) {
                // this.pendencias1 = erro.listaErros;
                this.listaErros += "Existem aditivos que não possuem Produtos vinculados. <br />"
              }
              if (err.includes("com o valor total dos produtos diferente do valor do aditivos")) {
                // this.pendencias2 = erro.listaErros;
                this.listaErros += "Existem aditivos que estão com o valor dos produtos diferente do total. <br />"
              }
              if (err.includes("sem a justificativa inserida no caso de passar do limite de valor")) {
                // this.pendencias3 = erro.listaErros;
                this.listaErros += "Existem aditivos que ultrapassaram o limite legal que não possuem justificativa. <br />"
              }
              if (err.includes("sem o termo de referência de um ou mais aditivos")) {
                // this.pendencias4 = erro.listaErros;
                this.listaErros += "Existem contratos sem o termo de referência de um ou mais aditivos inserido(s). <br />"
              }
            });

          }

          this.alertService.mostraAlerta("Módulo possui pendências e não pode ser finalizado.", this.listaErros);
          //+ "<br /> Por favor, verifique os itens marcados em vermelho.");

          this.loading = false;
        });
      }
    });
  }

  public sincronizarContratosEAditivos() {
    let idPca = this.PCAATiva.id;
    this.alertService.mostraAlerta("Atenção", "Importação dos contratos do SACC/SCC iniciada. O processo de importação pode demorar alguns minutos.");

    this.contratoService.importarContratos(idPca).subscribe(data => {
      this.verificaStatusModulo();
      console.log("Contratos e aditivos importados com sucesso.");
      this.contratoService.transferirContratosSACC(idPca).subscribe(data => {
        this.verificaStatusModulo();
        console.log("Contratos e aditivos transferidos com sucesso.");
        this.alertService.mostraAlerta("Atenção", "Importação/Atualização dos contratos e aditivos concluída com sucesso!");        
      }, error => {
        this.contratoService.deletarTemp(idPca).subscribe(data => {
          console.log("Contratos e aditivos TEMP deletados com sucesso.");
          console.log("Erro ao transferir contratos e aditivos.");
          console.log(JSON.stringify(error));
          this.alertService.mostraAlerta("Erro ao transferir contratos e aditivos.", error.mensagem);
        }, error => {
          this.verificaStatusModulo();
          console.log("Contratos e aditivos TEMP deletados com sucesso.");
          console.log("Erro ao transferir contratos e aditivos.");
          console.log(JSON.stringify(error));
          this.alertService.mostraAlerta("Erro ao transferir contratos e aditivos.", error.mensagem);
        });
        this.verificaStatusModulo();
      });
    }, error => {
      this.contratoService.deletarTemp(idPca).subscribe(data => {
        console.log("Contratos e aditivos TEMP deletados com sucesso.");
        console.log("Erro ao importar contratos e aditivos.");
        console.log(JSON.stringify(error));
        this.alertService.mostraAlerta("Erro ao importar contratos e aditivos.", error.mensagem);
      }, error => {
        this.verificaStatusModulo();
        console.log("Contratos e aditivos TEMP deletados com sucesso.");
        console.log("Erro ao importar contratos e aditivos.");
        console.log(JSON.stringify(error));
        this.alertService.mostraAlerta("Erro ao importar contratos e aditivos.", error.mensagem);
      });
      this.verificaStatusModulo();
    });
    this.voltarPCA();
  }

  public importarDocumentosContratosEAditivos() {
    let idPca = this.PCAATiva.id;
    this.alertService.mostraAlerta("Atenção", "Importação dos contratos do SACC/SCC iniciada. O processo de importação pode demorar alguns minutos.");

    this.contratoService.downloadArquivoContratosAditivos(idPca).subscribe(data => {
      this.verificaStatusModulo();
      console.log("Contratos e aditivos baixados com sucesso.");
      this.alertService.mostraAlerta("Atenção", "Importação dos documentos dos contratos e aditivos concluída com sucesso !");
      this.gestaoPcaService.importarEmpenhos(idPca).subscribe(data => {
        console.log("Empenhos importados com sucesso.");
      }, error => {
        this.verificaStatusModulo();
        console.log("Erro na importação dos empenhos.");
        console.log(JSON.stringify(error));
        this.alertService.mostraAlerta("Erro na importação dos empenhos.", error.mensagem + " Favor entrar em contato com a STI do TCE.");
      });
    }, error => {
      this.contratoService.deletarTemp(idPca).subscribe(data => {
        console.log("Contratos e aditivos TEMP deletados com sucesso.");
        console.log("Erro no download dos contratos e aditivos.");
        console.log(JSON.stringify(error));
        this.alertService.mostraAlerta("Erro no download dos contratos e aditivos.", error.mensagem + " Favor entrar em contato com a STI do TCE.");
      }, error => {
        this.verificaStatusModulo();
        console.log("Contratos e aditivos TEMP deletados com sucesso.");
        console.log("Erro no download dos contratos e aditivos.");
        console.log(JSON.stringify(error));
        this.alertService.mostraAlerta("Erro no download dos contratos e aditivos.", error.mensagem + " Favor entrar em contato com a STI do TCE.");
      });
      this.verificaStatusModulo();
    });
    this.voltarPCA();
  }

  exibirStatus(status) {
    this.alertService.mostraAlerta("Status", status);
  }

  formatarZeroEsquerda(valor) {
    return valor.replace(/^0+(?!\.|$)/, '');
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  printData() {

    this.loading = true;

    this.contratoService.listarPorPCA().subscribe(contratosFull => {
      var doc = new jsPDF("l");
      var totalPagesExp = "{total_pages_count_string}";

      var pageContent = function (data) {
        // HEADER
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');

        doc.text("Lista de Contratos", data.settings.margin.left + 15, 22);

        // FOOTER
        var str = "Page " + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + " of " + totalPagesExp;
        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
      };

      var columns = [
        { title: "Nº Contrato", dataKey: "nmContrato" },
        { title: "Valor Inicial", dataKey: "valorInicial" },
        { title: "Valor Atual SACC", dataKey: "valorAtual" },
        { title: "Contrato Enviado?", dataKey: "arquivoContrato" },
        { title: "Nº Aditivo", dataKey: "nmAditivo" },
        { title: "Tipo do Aditivo", dataKey: "tipoAditivo" },
        { title: "Valor do Aditivo", dataKey: "valorAditivo" },
        { title: "Valor Acumulado", dataKey: "valorAcumulado" }
      ];

      let rows = [];

      contratosFull.forEach(contrato => {

        if (contrato.aditivos) {
          contrato.aditivos.forEach(aditivo => {

            var item = {
              "nmContrato": this.formatarZeroEsquerda(contrato.nmContrato),
              "valorInicial": this.formatarValorNumerico(contrato.valorInicial),
              "valorAtual": this.formatarValorNumerico(contrato.valorAtual),
              "arquivoContrato": contrato.arquivos.length >= 1 ? "Sim" : "Não",
              "nmAditivo": aditivo.nmAditivo,
              "tipoAditivo": aditivo.tipoAditivo,
              "valorAditivo": this.formatarValorNumerico(aditivo.valor),
              "valorAcumulado": this.formatarValorNumerico(aditivo.valorComContrato)
            };

            rows.push(item);
          });
        } else {
          var item = {
            "nmContrato": this.formatarZeroEsquerda(contrato.nmContrato),
            "valorInicial": this.formatarValorNumerico(contrato.valorInicial),
            "valorAtual": this.formatarValorNumerico(contrato.valorAtual),
            "arquivoContrato": contrato.arquivos.length >= 1 ? "Sim" : "Não",
            "nmAditivo": '',
            "tipoAditivo": '',
            "valorAditivo": '',
            "valorAcumulado": ''
          };

          rows.push(item);
        }
      });

      doc.autoTable(columns, rows, {
        theme: 'grid',
        addPageContent: pageContent,
        margin: { top: 30 },
        styles: {
          overflow: 'linebreak',
          columnWidth: 'wrap',
          fontSize: 9
        },
        columnStyles: {
          text: { columnWidth: 'auto' },
          nmContrato: { columnWidth: 20 },
          valorInicial: { columnWidth: 25 },
          valorAtual: { columnWidth: 25 },
          arquivoContrato: { columnWidth: 25 },
          nmAditivo: { columnWidth: 20 },
          tipoAditivo: { columnWidth: 85 },
          valorAditivo: { columnWidth: 25 },
          valorAcumulado: { columnWidth: 25 }
        }
      });

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }

      doc.save('lista_contratos.pdf');
      this.loading = false;
    }, error => {
      this.alertService.mostraAlerta('Atenção!', 'Erro ao imprimir os dados do Contrato.');
      this.loading = false;
    });
  }

  printDataAcimaLimite() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Acréscimos ou Supressões de Contratos versus Limite Legal", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var data = [];

    var columns = [
      { title: "Dados Contrato", dataKey: "contrato" },
      { title: "Nº", dataKey: "num" },
      { title: "Tipo", dataKey: "tipo" },
      { title: "Valor", dataKey: "valor" },
      { title: "Acréscimo", dataKey: "acr" },
      { title: "Supressão", dataKey: "sup" },
      { title: "Justificativa para Descumprimento do Limite Legal", dataKey: "justificativa" }
    ];

    let rows = [];

    this.listaDadosAcrescimo.analises.forEach(item => {

      let contador = 1;

      if (item.contrato.aditivos) {
        item.contrato.aditivos.forEach(aditivo => {

          let newItem = {
            "contrato": {
              value: "Nº Contrato: " + this.formatarZeroEsquerda(item.contrato.nmContrato)
                + "\n Contratado: " + item.contrato.credor
                + "\n Valor Original: R$ " + this.formatarValorNumerico(item.contrato.valorInicial)
                + "\n Valor Atualizado SACC: R$ " + this.formatarValorNumerico(item.contrato.valorAtual)
                + "\n Base de Cálculo: R$ " + this.formatarValorNumerico(item.valorAtualizadoCalculado), rowspan: item.contrato.aditivos.length, campo: "contrato", id: contador
            },
            "num": aditivo.nmAditivo,
            "tipo": aditivo.tipoAditivo,
            "valor": this.formatarValorNumerico(aditivo.valor),
            "acr": this.formatarValorNumerico(aditivo.totalAcrescimo),
            "sup": this.formatarValorNumerico(aditivo.totalSupressao),
            "justificativa": { value: item.justificativa, rowspan: item.contrato.aditivos.length, campo: "justificativa", id: contador }
          };

          data.push(newItem);

          contador++;

        });
      }
    });

    doc.autoTable(columns, data, {
      theme: 'grid',
      addPageContent: pageContent,
      margin: { top: 30 },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'wrap',
        fontSize: 5
      },
      columnStyles: {
        text: { columnWidth: 'auto' },
        contrato: { columnWidth: 83 },
        num: { columnWidth: 7 },
        tipo: { columnWidth: 43 },
        valor: { columnWidth: 22 },
        acr: { columnWidth: 22 },
        sup: { columnWidth: 22 },
        justificativa: { columnWidth: 70 }
      },
      drawCell: function (cell, data) {
        cell.height = cell.height * 2;
        console.log(cell);
        // Rowspan
        if (data.column.dataKey === 'contrato') {

          if (data.row.index !== 0 && cell.raw.campo === "contrato") {

            if (cell.raw.id === cell.raw.rowspan) {

              doc.rect(cell.x, cell.y - (cell.height * cell.raw.rowspan) + cell.height, cell.width, cell.height * cell.raw.rowspan, 'S');
              doc.autoTableText(cell.raw.value, cell.x + 5, (cell.y - (cell.height * cell.raw.rowspan) + (cell.height * 3)), {
                halign: 'left',
                valign: 'middle'
              });
            }
          }
          return false;
        }

        if (data.column.dataKey === 'justificativa') {

          if (data.row.index !== 0 && cell.raw.campo === "justificativa") {

            if (cell.raw.id === cell.raw.rowspan) {

              doc.rect(cell.x, cell.y - (cell.height * cell.raw.rowspan) + cell.height, cell.width, cell.height * cell.raw.rowspan, 'S');
              doc.autoTableText(cell.raw.value, cell.x + 5, (cell.y - (cell.height * cell.raw.rowspan) + (cell.height * 3)), {
                halign: 'left',
                valign: 'middle'
              });
            }
          }

          return false;
        }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('lista_acrescimos_supressoes_acima_limite.pdf');
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 5).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTRATO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  visualizarProdutos(aditivo, contrato) {
    let titulo = "Produtos do Aditivo " + aditivo.nmAditivo;

    let modal = this.modalCtrl.create(ModalProdutoContratoPage,
      {
        param1: titulo,
        idModuloPca: contrato.idModuloPca,
        aditivo: aditivo,
        jurisdicionado: false,
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.carregarDados();
      }
    });

    modal.present();
  }
  subscription: Subscription;
  ngOnInit(): void {
    if (!ContratosPage.isAlertaAberto && this.isJurisdicionado) {
      this.alertService.mostraAlerta('Atenção!', 'Não é necessário fazer o upload dos arquivos (contratos e aditivos) no Ágora. Eles serão recuperados do SACC/SCC.\n' +
        'Na ausência desses arquivos, os ajustes deverão ser realizados no SACC/SCC.');
      ContratosPage.isAlertaAberto = true;
    }
    this.verificaStatusModulo();
    this.subscription = this.contratoService.statusDoModulo$.subscribe(data => {
      console.log(data);
      this.habilitaBotaoImportaContrato = !data;
    });
    console.log("Init")

  }

  verificaStatusModulo(): void {
    let idStatusModulo;
    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 5).subscribe(data => {
      idStatusModulo = data.idStatusModulo
      console.log("idStatusModulo: " + data.moduloPca);
      console.log("idStatusModulo: " + idStatusModulo);
      if (idStatusModulo == 8) {
        this.habilitaBotaoImportaContrato = false;
      }
      this.contratoService.verificaSatusModuloPca(idStatusModulo);
    });
  }

  ngOnDestroy(): void {
    ContratosPage.isAlertaAberto = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  loadPage(Page: number) {
    this.pagination.CurrentPage = Page;
    this.loadingPagContrato = true;
    this.contratoService.listarPorPCAPag(Page, this.filter.nmContrato).subscribe(data => {
      this.listaDados = data.contratosModel;
      this.loadingPagContrato = this.loading = false;
      this.pagination.TotalItems = data.qtdPags;
    }, error => {
      console.log("erro: " + error.mensagem);
      this.loadingPagContrato = this.loading = false;
    });
  }

  filtraContratos() {
    if (this.filter.nmContrato.length > 2 || this.filter.nmContrato.length == 0) {
      this.loadPage(1);
    }
  }


  questionarCriacaoResumoContratos() {

    let aditivosSemDetalhamento = [];

    this.listaDados.forEach(contrato => { 
      if (contrato.aditivos)      {
        aditivosSemDetalhamento = contrato.aditivos.filter(aditivo => aditivo.produtos.length == 0);
      }
    });

    if (aditivosSemDetalhamento.length > 0) {
      this.alertService.mostraModalConfirmacao('Aditivos sem detalhamento', 'Alguns aditivos estão sem detalhamento. Confirma a criação do resumo?', (confirma) => {
        if (confirma) {
          this.gerarResumoContratos();
        }
      });
    } else {
      this.gerarResumoContratos();
    }
  }

  private gerarResumoContratos() {

    this.disbaleBotaoGerarResumoContrato = true;
    const dadosPca = {
      idPca: this.PCAATiva.id, 
      idModuloPca: this.codigoModulo, 
      idResumoContratos: this.resumoContratoArquivo ? this.resumoContratoArquivo.idArquivoVinculado : 0
    };

    this.loadingGerarResumoContrato = true;
    this.contratoService.gerarDocModuloContrato(dadosPca)
                  .then( doc => {
                    this.resumoContratoArquivo = doc;
                    this.loadingGerarResumoContrato = false;
                    this.disbaleBotaoGerarResumoContrato = false;
                    this.alertService.mostrarToast('Resumo gerado com sucesso.');
                  })
                  .catch( error => {
                    this.loadingGerarResumoContrato = false;
                    this.disbaleBotaoGerarResumoContrato = false;
                    this.alertService.mostrarToast(error);
                    console.log('Erro ao gerar o documento', error);
                  });
  }

  public iniciarAssinaturaResumoContratos() {
    
    const cpfSemFormatacao = environment.production ? this.usuario.dadosUsuario[0].cpf : environment.cpfAssinateTeste;
    const cpf = this.formatarCpf(cpfSemFormatacao);

    const opcoes = {
      arquivos: [this.resumoContratoArquivo.pathArquivo],
      cpfUsuarioLogado: cpfSemFormatacao,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [{
        idPca: this.PCAATiva.id, 
        idDocumento: this.resumoContratoArquivo.idArquivoVinculado,
        cpfAssinante: cpf,
        perfil: this.usuarioService.obterDadosUsuario().perfil
      }],
      idPca: this.PCAATiva.id,
      tipoArquivo: 'TIPO_VINCULADO'
    };

    this.assinaturaService.iniciarAssinatura(opcoes);

  }

  visualizarResumoContratos() {
    this.loading = true;
    this.fileService.baixarArquivo(this.resumoContratoArquivo.idArquivoVinculado);
    this.loading = false;
  }
  
  private sucessoAssinatura() {
/*    console.log('Assinou');
    this.isAssinando = true;
    this.carregaListaPCAS();*/
  }

  private formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }


  excluirContrato(contrato) {
    console.log(contrato);
    this.alertService.mostraModalConfirmacao("Excluir contrato", "Deseja excluir o contrato?", callback => {
      if (callback) {
          this.loading = true;
          this.contratoService.deletarContrato(contrato.id).subscribe(
            data => {
              this.loadPage(this.pagination.CurrentPage);
              this.loading = false;
              this.alertService.mostraAlerta("", data.mensagem);
            }, 
            error => {
              this.loading = false;
              this.alertService.mostraAlerta("", error.mensagem);
            }
          );
      }
    });    
  }

  excluirAditivo(aditivo) {
    console.log(aditivo);
    this.alertService.mostraModalConfirmacao("Excluir aditivo", "Deseja excluir o aditivo?", callback => {
      if (callback) {
          this.loading = true;
          this.contratoService.deletarAditivo(aditivo.id).subscribe(
            data => {
              this.loadPage(this.pagination.CurrentPage);
              this.loading = false;
              this.alertService.mostraAlerta("", data.mensagem);
            }, 
            error => {
              this.loading = false;
              this.alertService.mostraAlerta("", error.mensagem);
            }
          );
      }
    });    
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contratos.ts